export default String.raw`
{% assign orgNameSource = config.Shop.ShortName -%}
{% if orgNameSource == null or orgNameSource == '' -%}
    {% assign orgNameSource = config.Shop.Name -%}
{% endif -%}
{% assign orgName = orgNameSource | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgLegalName = config.Shop.Name | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgStreet = '' -%}
{% if config.Shop.Address.Street != null and config.Shop.Address.Street != '' -%}
    {% assign orgStreet = config.Shop.Address.Street -%}
{% endif -%}
{% if config.Shop.Address.StreetNo != null and config.Shop.Address.StreetNo != '' -%}
    {% if orgStreet != '' -%}
        {% assign orgStreet = orgStreet | Append: ' ' -%}
    {% endif -%}
    {% assign orgStreet = orgStreet | Append: config.Shop.Address.StreetNo -%}
    {% if config.Shop.Address.UnitNo != null and config.Shop.Address.UnitNo != '' -%}
        {% assign orgStreet = orgStreet | Append: '/' | Append: config.Shop.Address.UnitNo -%}
    {% endif -%}
{% endif -%}
{% assign orgStreet = orgStreet | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' | Replace: '[ ]{2,}', ' ' | Replace: '[ ]+$', '' -%}
{% assign orgCity = config.Shop.Address.City | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgZipCode = config.Shop.Address.ZipCode | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgState = config.Shop.Address.State | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgCountry = config.Shop.Address.Country | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgFax = config.Shop.Contact.Fax | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgPhone = config.Shop.Contact.PhoneNo | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgTaxID = config.Shop.TIN | StripHtml | Replace: '[\r\n\t]+', ' ' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgEmail = config.Shop.Contact.Email | StripHtml | Replace: '[\r\n\t]+', '' | StripNewlines | Replace: '\\', '' | Replace: '"', '\"' -%}
{% assign orgHasAddress = false -%}
{% if orgStreet != '' or orgCity != '' or orgZipCode != '' or orgState != '' or orgCountry != '' -%}
    {% assign orgHasAddress = true -%}
{% endif -%}
{% assign orgSameAsCount = 0 -%}
{% capture orgSameAsItems -%}
    {% for sm in config.Footer.JoinUs -%}
        {% assign smArr = sm | Split: '|||' -%}
        {% assign smLinks = smArr[3] | Split: '||' -%}
        {% for smLink in smLinks -%}
            {% assign smUrl = smLink | Split: '|' -%}
            {% assign smHref = smUrl[0] | StripNewlines | Replace: '[\r\n\t]+', '' -%}
            {% if smHref contains 'http' -%}
                {% if orgSameAsCount > 0 %},{% endif -%}
                {% assign orgSameAsCount = orgSameAsCount | Plus: 1 -%}
                "{{smHref | Replace: '\\', '' | Replace: '"', '\"'}}"
            {% endif -%}
        {% endfor -%}
    {% endfor -%}
{% endcapture -%}
{% capture orgBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% assign orgProtocol = orgBase | Split: '//' | First -%}
{% assign orgHost = orgBase | Split: '//' | Last | Split: '/' | First -%}
{% capture orgRoot -%}{{ orgProtocol }}//{{ orgHost }}/{% endcapture -%}
{% if config.Shop.ImageUrl contains '//' -%}
    {% assign orgLogo = config.Shop.ImageUrl -%}
{% elsif config.Shop.ImageUrl != null and config.Shop.ImageUrl != '' -%}
    {% capture orgLogo -%}{{ orgRoot }}{{ config.Shop.ImageUrl | Replace: '^[./]+', '' }}{% endcapture -%}
{% else -%}
    {% assign orgLogo = '' -%}
{% endif -%}
<script type="application/ld+json">
    {
      "@context" : "https://schema.org",
      "@type" : "Organization"
      {% if orgHost != null and orgHost != '' -%}
      ,"@id" : "{{orgRoot}}#organization"
      ,"url" : "{{orgRoot}}"
      {% if orgLogo != '' -%}
      ,"logo" : "{{orgLogo}}"
      {% endif -%}
      {% endif -%}
      {% if orgName != '' -%}
      ,"name": "{{orgName}}"
      {% endif -%}
      {% if orgLegalName != '' and orgLegalName != orgName -%}
      ,"legalName": "{{orgLegalName}}"
      {% endif -%}
      {% if orgHasAddress -%}
      ,"address": {
        "@type": "PostalAddress"
        {% if orgStreet != '' -%}
        ,"streetAddress": "{{orgStreet}}"
        {% endif -%}
        {% if orgCity != '' -%}
        ,"addressLocality": "{{orgCity}}"
        {% endif -%}
        {% if orgZipCode != '' -%}
        ,"postalCode": "{{orgZipCode}}"
        {% endif -%}
        {% if orgState != '' -%}
        ,"addressRegion": "{{orgState}}"
        {% endif -%}
        {% if orgCountry != '' -%}
        ,"addressCountry" : "{{orgCountry}}"
        {% endif -%}
      }
      {% endif -%}
      {% if orgFax != '' -%}
      ,"faxNumber" : "{{orgFax}}"
      {% endif -%}
      {% if orgPhone != '' -%}
      ,"telephone" : "{{orgPhone}}"
      {% endif -%}
      {% if orgEmail != '' -%}
      ,"email" : "{{orgEmail}}"
      {% endif -%}
      {% if orgTaxID != '' -%}
      ,"taxID" : "{{orgTaxID}}"
      {% endif -%}
      {% if orgSameAsCount > 0 -%}
      ,"sameAs": [{{orgSameAsItems}}]
      {% endif -%}
    }
</script>
`